import React from 'react';
import { Link } from 'react-router-dom';
import { toDateString } from '../../../util/DateUtility';
import Has from '../../../component/Permission/Has';
import { REGISTER_COMPANIES } from '../../../config/PermissionTypes';
import { getUrl } from '../../../util/EfupUtility';

export default function CompanyDetailsOverview(props) {
    const { company } = props;

    if (company === null) {
        return <div>Company details not found.</div>
    }

    //check for null dates
    const registeredDate = company.registeredDate ? toDateString(company.registeredDate) : "N/A";
    const lastModifiedDate = company.lastModifiedDate ? toDateString(company.lastModifiedDate) : "N/A";

    return (
        <div className="efup-company-details-side-panel-overview" data-testid="efup-company-details-side-panel-overview">
            <div className="efup-side-panel-line">
                <table className="table table-borderless" data-testid="efup-overview-tab-body">
                    <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="efup-side-panel-label">Company Name:</td>
                            <td className="efup-side-panel-data" data-testid="efup-overview-tab-company-name">{company.companyName}</td>
                        </tr>
                        <tr>
                            <td className="efup-side-panel-label">Company Number:</td>
                            <td className="efup-side-panel-data" data-testid="efup-overview-tab-comapny-number">{company.companyNumber}</td>
                        </tr>
                        <tr>
                            <td className="efup-side-panel-label">Registered Date:</td>
                            <td className="efup-side-panel-data" data-testid="efup-overview-tab-registered-date">{registeredDate}</td>
                        </tr>
                        <tr>
                            <td className="efup-side-panel-label">Last Modified Date:</td>
                            <td className="efup-side-panel-data" data-testid="efup-overview-tab-last-modified-date">{lastModifiedDate}</td>
                        </tr>
                        <tr>
                            <td className="efup-side-panel-label">Modified By:</td>
                            <td className="efup-side-panel-data" data-testid="efup-overview-tab-modified-by">{company.modifiedBy}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <Has permission={REGISTER_COMPANIES}>
                <div className="ocButtons">
                    <Link tabIndex="-1"
                        to={`/system/registerCompany/${company.companyNumber}/edit`}
                        state={{ uuid: company.uuid, companyNumber: company.companyNumber }}
                        data-testid={`edit-company-link-${company.companyNumber}`}
                    >
                        <button type="button" className="oc-blue-btn" data-testid="efup-overview-tab-edit-company-button">Edit Company</button>
                    </Link>
                </div>
            </Has>
        </div>
    );
}